import { RequestConfig } from '@/interface'
const PRIFIX = 'adminRole/'

const roleConfig: RequestConfig = {
  addAdminRole: {
    // 新增角色
    url: `${PRIFIX}add`,
    method: 'post'
  },
  deleteAdminRole: {
    // 删除角色
    url: `${PRIFIX}delete`,
    method: 'post'
  },
  updateAdminRole: {
    // 编辑角色
    url: `${PRIFIX}update`,
    method: 'post'
  },
  updateRoleMenu: {
    // 保存角色菜单关系
    url: `${PRIFIX}updateRoleMenu`,
    method: 'post'
  },
  copyAdminRole: {
    // 复制角色
    url: `${PRIFIX}copy`,
    method: 'post'
  },
  relatedDeptUser: {
    // 复制员工角色
    url: `${PRIFIX}relatedDeptUser`,
    method: 'post'
  },
  relatedUser: {
    // 添加编辑员工
    url: `${PRIFIX}relatedUser`,
    method: 'post'
  },
  unbindingUser: {
    // 删除员工
    url: `${PRIFIX}unbindingUser`,
    method: 'post'
  },
  getRoleTypeList: {
    // 角色分类列表
    url: `${PRIFIX}getRoleTypeList`,
    method: 'post'
  },
  getRoleByType: {
    // 根据角色类型查询角色列表
    url: `${PRIFIX}getRoleByType`,
    method: 'post'
  },
  getMenuListByType: {
    // 规则
    url: 'adminMenu/getMenuListByType',
    method: 'post'
  },
  queryRoleField: {
    // 查询字段授权设置
    url: `${PRIFIX}queryRoleField`,
    method: 'post'
  },
  saveRoleField: {
    // 模块设置字段授权
    url: `${PRIFIX}saveRoleField`,
    method: 'post'
  },
  roleAuth: {
    // 角色权限
    url: `${PRIFIX}auth`,
    method: 'post'
  },
  saveRoleDataType: {
    // 保存用户数据权限
    url: `${PRIFIX}saveRoleDataType`,
    method: 'post'
  },
  queryRoleDataType: {
    // 查询用户的数据权限
    url: `${PRIFIX}queryRoleDataType`,
    method: 'get'
  }
}
export default roleConfig
